
import Header from "@/components/header/header.vue";
import Address from "@/components/address/index.vue";
import ListEmpty from '@/components/list_empty.vue'
import { inject, ref, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
export default {
  components: {
    Header,
    Address,
    ListEmpty
  },
  setup() {
    const $http: any = inject("$http");
    const router: any = useRouter();
    const $store: any = inject('$store');
    let route = useRoute()
    let is_checkout = ref(route.query.is_checkout)
    let loading = ref(true)

    let skipPath = ref($store.getGoBack())
    let address_list: any = ref();
    let loadRender = async () => {
      const res = await $http.post_address({ action: "select" });
      if (res.code === 200) {
        address_list.value = res.data;
        loading.value = false
      }
    };
    //删除
    let delete_fn = async (val: any) => {
      const res = await $http.delete_address({
        id: val.address_id,
        action: "delete",
      });
      if (res.code === 200) {
        loadRender();
      }
    };
    //编辑
    let edit_fn = (val: any) => {
      let parms = {
        phone: val.phone,
        firstName: val.firstname,
        LastName: val.lastname,
        country_code: val.area_code,
        is_default: val.is_default === 1 ? true : false,
        action: "update",
        address_id: val.address_id,
      };
      common.setStorage("address", parms, 15);
      const queryData:any = {
        row_id: val.city_id,
          town_name: val.city_name,
          area_name: val.pronvice_name,
          area_id: val.pronvice_id,
          pickup_id: val.dlyp_id,
          pickup_name: val.address,
      }
      if (Number(route.query.isShowCheck) > 0 || route.query.isShowCheck === 'afterSale') {
        queryData.isShowCheck= 1
      } 
      router.push({
        path: "/address-adds",
        query: queryData,
      });
    };
    let jumpAddress = () => {
      common.delStorage("address");
      if (route.query.is_checkout) {
        router.push({
          path: "/address-adds",
          query: {
            is_checkout: 1
          }
        });
      } else if (route.query.isShowCheck) {
        router.push({
          path: "/address-adds",
          query: {
            isShowCheck: 1,
            isFiltrate: route.query.isFiltrate ? route.query.isFiltrate:'0'
          }
        });
      } else {
        router.push('/address-adds')
      }
    };
    loadRender();
    return {
      address_list,
      delete_fn,
      jumpAddress,
      edit_fn,
      skipPath,
      loading
    };
  },
};
